import React from 'react';
import { Outlet } from 'react-router-dom';

interface RootPageInterface {}

const RootPage: React.FC<RootPageInterface> = () => <Outlet />;

export default RootPage;
